import NetworkPage from '@modules/professional/page/NetworkPage';
import { loader } from '@modules/professional/page/loaders/network-page-loader.server';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import type { APHandle } from '~/modules/root';

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};
export const handl: APHandle = {
    disabledInPreview,
};
export { loader };
export default NetworkPage;
